export const mockApiData = {
    availability: [
        {
            label: 'Free',
            description: 'Free'
        },
        {
            label: 'propaganda',
            description: 'Free com propaganda'
        },
        {
            label: 'Fechada',
            description: 'Fechada'
        },
    ],

    prediction: [
        {
            label: 'sem_previsao',
            description: 'Sem previsão'
        },
        {
            label: 'cumbuco_beach',
            description: 'cumbuco_beach'
        },
        {
            label: 'praia_do_futuro',
            description: 'praia_do_futuro'
        },
        {
            label: 'ubatuba',
            description: 'ubatuba'
        },
        {
            label: 'maresias',
            description: 'maresias'
        },
        {
            label: 'guaruja_praia_da_enseada',
            description: 'guaruja_praia_da_enseada'
        },
        {
            label: 'ilha-do-mel',
            description: 'ilha-do-mel'
        },
        {
            label: 'guaratuba',
            description: 'guaratuba'
        },
        {
            label: 'navegantes_itajai',
            description: 'navegantes_itajai'
        },
        {
            label: 'florianopolis_praia_mole',
            description: 'florianopolis_praia_mole'
        },
        {
            label: 'garopaba',
            description: 'garopaba'
        },
        {
            label: 'balneario_rincao',
            description: 'balneario_rincao'
        },
        {
            label: 'torres',
            description: 'torres'
        },
        {
            label: 'tramandai',
            description: 'tramandai'
        },
        {
            label: 'natal',
            description: 'natal'
        },
        {
            label: 'tabatinga',
            description: 'tabatinga'
        },
        {
            label: 'pipa',
            description: 'pipa'
        },
        {
            label: 'rio_de_janeiro_rio_de_janeiro_brazil',
            description: 'rio_de_janeiro_rio_de_janeiro_brazil'
        },
        {
            label: 'saquarema_rio_de_janeiro_brazil',
            description: 'saquarema_rio_de_janeiro_brazil'
        },
    ]
}
